module.exports = __webpack_public_path__ + "media/es.886ab6c9.mp3";